import React from "react";
import { ArrowRight, Phone, Mail } from "lucide-react";
import CTAButton from "../ui/CTAButton";

const ContactCTA = () => {
  return (
    <section className="py-20 bg-psa-green-600 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute right-0 bottom-0 w-96 h-96 bg-white rounded-full"></div>
        <div className="absolute left-20 top-20 w-64 h-64 bg-white rounded-full"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 font-display">
            Ready to Get Expert Financial Guidance?
          </h2>
          <p className="text-psa-green-100 text-lg mb-8 max-w-2xl mx-auto">
            Contact us today to discuss how our professional services can help
            you optimize your Tax, VAT, RJSC, BIDA position and achieve your
            business goals.
          </p>

          <div className="flex flex-col md:flex-row md:space-x-8 space-y-4 md:space-y-0 justify-center mb-10">
            <a
              href="tel:+8801710908697"
              className="flex items-center justify-center gap-3 text-white hover:underline transition duration-300"
            >
              <Phone size={20} className="text-psa-gold-300" />
              <span className="font-medium">+88 01710-908697</span>
            </a>
            <a
              href="mailto:miahmasum04@gmail.com"
              className="flex items-center justify-center gap-3 text-white hover:underline transition duration-300"
            >
              <Mail size={20} className="text-psa-gold-300" />
              <span className="font-medium">miahmasum04@gmail.com</span>
            </a>
          </div>

          <CTAButton
            to="/contact"
            className="bg-white hover:bg-gray-100 text-psa-green-600 font-semibold"
            primary={false}
          >
            <span className="flex items-center">
              Contact Us Now
              <ArrowRight size={18} className="ml-2" />
            </span>
          </CTAButton>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;
